import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart-fill.svg",
  "use": "heart-fill.svg-usage",
  "viewBox": "0 0 24 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 22\" id=\"heart-fill.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.2 0A7.762 7.762 0 0012 1.226 7.764 7.764 0 007.8 0C3.5 0 0 3.5 0 7.8c0 3.574 2.56 6.044 4.616 8.03.301.29.598.576.882.862 1.724 1.735 4.863 4.269 4.995 4.376a2.396 2.396 0 003.014 0c.132-.107 3.27-2.641 4.995-4.376.284-.286.581-.572.882-.863C21.44 13.844 24 11.374 24 7.8 24 3.5 20.5 0 16.2 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol